// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"8b8ef153","496":"dde6890a","839":"87362457","896":"3dfd0d04"}[chunkId] + ".chunk.js";
};